// Şirket künyesi — TEK kaynak (Footer + İletişim sayfası buradan okur).
// 6563 sayılı Kanun ve ETHS Yönetmeliği m.5 gereği ticaret unvanı, MERSİS no,
// merkez adresi, KEP adresi, e-posta ve telefon ana sayfadan doğrudan ulaşılan
// "İletişim" başlığı altında gösterilmek zorundadır. Değerler ETBİS kaydıyla
// (Eylül 2026) birebir aynıdır; biri değişirse ETBİS de 30 gün içinde güncellenir.
export const COMPANY_INFO = {
  legalName: 'Arkaya Arge Yazılım İnşaat Ticaret Limited Şirketi',
  mersis: '0079089736400001',
  address:
    'Göller Bölgesi Teknokenti, Süleyman Demirel Üniversitesi Doğu Yerleşkesi, Çünür Mah. 102. Cad. No: 252, Giriş Kat, Ofis No: 102, Merkez / Isparta',
  kep: 'arkayaarge@hs01.kep.tr',
  email: 'info@katipotomasyonu.com',
  phone: '+90 501 544 85 44',
  phoneHref: 'tel:+905015448544',
  // ETBİS kaydı (Eylül 2026). true iken footer, İletişim sayfası ve ana sayfadaki
  // "Güvenlik & Ödeme" kartı "ETBİS'e kayıtlıdır" der ve kaydın KENDİ sonuç sayfasına
  // bağlanır (25.09.2026 — eskiden genel sorgulama sayfasıydı, ziyaretçi alan adını
  // kendisi aratıyordu). siteId Bakanlığın katipotomasyonu.com'a verdiği kalıcı kimliktir.
  // Kayıt Bakanlıkça askıya alınırsa false yapın. Karekod/rozet programı 02.09.2025'te
  // sonlandırıldı — siteye gömülecek bir kod yoktur.
  etbisRegistered: true,
  etbisQueryUrl: 'https://etbis.ticaret.gov.tr/tr/SiteSorgulamaSonuc?siteId=525f43e8-4ec7-4ced-8a44-674c95838bff',
};
